import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getNotifications } from '@portal/actions/notification';

export const useNotifications = () => {
  const dispatch = useDispatch();

  const notifications = useSelector(
    (state: reducers.rootReducer) => state.notification.list
  );

  const notificationsCount = useSelector(
    (state: reducers.rootReducer) => state.notification.listCount
  );

  const loading = useSelector(
    (state: reducers.rootReducer) => state.notification.loading
  );

  const fetchNotifications = (params?: advancedFilterModels.baseFilter) => {
    const defaultParams: advancedFilterModels.baseFilter = {
      page: 0,
      pageSize: 10,
      orderBy: 'createdAt',
      sort: 'desc',
      ...params,
    };

    dispatch(getNotifications(defaultParams));
  };

  const getUnreadCount = () => {
    // For now, we'll return 0 as unread count
    // In the future, this could be calculated based on notification status
    return 0;
  };

  useEffect(() => {
    // Fetch notifications on mount
    fetchNotifications();
  }, []);

  return {
    notifications,
    notificationsCount,
    loading,
    unreadCount: getUnreadCount(),
    fetchNotifications,
  };
};
